import { parse, addYears, subDays, isFuture } from "date-fns";
import { getNumbersFromDateString, getDayMonthYearFromDDMMYYYY } from '@/utils/date-helpers';

export const validationHandler = (callback, errorText, resolve) => {
    let validationSuccess;

    if (typeof callback === 'function') {
        // for function
        validationSuccess = callback();
    } else if (typeof callback === 'boolean') {
        // for computed
        validationSuccess = callback;
    }

    if (validationSuccess) {
        resolve();
    }   
    else {
        resolve(new Error(errorText));
    }
}

export const isValidDate = (dateObj) => {
    return dateObj instanceof Date && !isNaN(dateObj);
}

export const getValidDate = (dateString) => {
    let validString = getNumbersFromDateString(dateString);
    let [day, month, year] = getDayMonthYearFromDDMMYYYY(validString);
    const today = new Date();

    const monthIsFilled = month.length === 2;
    const yearIsFilled = year.length === 4;
    const inputOverload = validString.length > 8;

    const months_31_days = [1, 3, 5, 7, 8, 10, 12];
    const months_30_days = [4, 6, 9, 11];
    const years_with_29_feb_days = [1904, 1908, 1912, 1916, 1920, 1924, 1928, 1932, 1936, 1940, 1944, 1948, 1952, 1956, 1960, 1964, 1968, 1972, 1976, 1980, 1984, 1988, 1992, 1996, 2000, 2004, 2008, 2012, 2016, 2020, 2024, 2028, 2032, 2036, 2040];
    const MINIMAL_YEAR = years_with_29_feb_days[0];

    // day minmax
    if (+day > 31) day = '31';
    else if (day === '00') day = '01';

    // month minmax
    if (+month > 12) month = '12';
    else if (month === '00') month = '01';

    //cases
    if (+day === 31 && monthIsFilled) {
        if (!months_31_days.includes(+month)) {
            day = "30"
        }
    }
    if (+day === 30 && monthIsFilled) {
        if (!months_30_days.includes(+month) && !months_31_days.includes(+month)) {
            day = "29"
        }
    }

    // year minmax
    if (inputOverload) year = today.getFullYear().toString();
    if (+year < MINIMAL_YEAR && yearIsFilled) year = MINIMAL_YEAR.toString();

    // february case
    if (+day === 29 && yearIsFilled) {
        if (!years_with_29_feb_days.includes(+year)) {
            day = '28'
        }
    }

    validString = `${day}${month ? '.' + month : ''}${year ? '.' + year : ''}`;

    return validString
}

export const clientPassportIssueIsInvalid = (issueDateString, birthDateString) => {
    const issueDate = parse(issueDateString, 'dd.MM.yyyy', new Date());
    const birthDate = parse(birthDateString, 'dd.MM.yyyy', new Date());
    const today = new Date();

    // проверка что даты не являются InvalidDate
    if (!isValidDate(issueDate) || !isValidDate(birthDate)) {
        true
    }

    let birthPlus14Years = addYears(birthDate, 14);
    
    if (issueDate < birthPlus14Years) {
        // дата выдачи паспорта должна быть больше чем дата рождения + 14 лет
        return true
    } else if (issueDate > subDays(today, 1)) {
        // дата выдачи паспорта должна быть меньше чем сегодня - один день
        return true
    }

    return false
}
